'use strict';

var SoaModel = require('bunsen/models/SoaModel');
var EcomCharge = module.exports = SoaModel.extend();

var _ = require('underscore');
var endpoints = require('dibs-endpoints');
var Backbone = require('dibs-backbone');

var Party = require('bunsen/models/Party');
var FinancialAmount = require('bunsen/models/FinancialAmount');

_.extend(EcomCharge, {

});

_.extend(EcomCharge.prototype, {
    relations : SoaModel.createRelations([
        {
            key : 'chargeParty',
            relatedModel : Party,
            type : Backbone.One
        },
        {
            key : 'amount',
            relatedModel : FinancialAmount,
            type : Backbone.One
        }

    ])
});




//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/EcomCharge.js
// module id = 173
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56